import { View } from 'react-native';
const SafeAreaView = View;
export default SafeAreaView;
//# sourceMappingURL=SafeAreaView.web.js.map